import { fromJS } from 'immutable';
import * as coursewareTypes from 'pluginServices/constants/coursewareTypes';
import activityService from 'services/ActivityService';
import componentService from 'services/ComponentService';
import interactiveService from 'services/InteractiveService';

import { activePlugins, startPluginShared, startPluginInitChild } from './index';

function getCourseware(coursewareType, instanceId) {
  switch (coursewareType) {
    case coursewareTypes.ACTIVITY:
      return activityService.getActivity(instanceId);
    case coursewareTypes.COMPONENT:
      return componentService.getComponent(instanceId);
    case coursewareTypes.INTERACTIVE:
      return interactiveService.getInteractive(instanceId);
    default:
      return activityService.getActivity(instanceId);
  }
}

// main entry point for creating a plugin view
async function invokePlugin(instanceId, coursewareType, manifest, element, context, respondToInitChildCallback) {
  let courseware;

  const activePlugin = activePlugins.get(instanceId);
  if (activePlugin && activePlugin?.context === context && activePlugin?.plugin) {
    courseware = {
      ...activePlugin,
      element,
      context,
      respondToInitChildCallback,
    };
  } else {
    const coursewareConfig = await getCourseware(coursewareType, instanceId) || {};

    courseware = {
      ...coursewareConfig,
      element,
      context,
      respondToInitChildCallback,
    };
  }

  activePlugins.set(instanceId, courseware);

  if (!courseware?.plugin) {
    return;
  }

  const {plugin} = courseware;
  activePlugins.set(instanceId, {
    element,
    context,
    respondToInitChildCallback,
    plugin,
  });

  // start up the plugin && check if custom slate plugins contains plugin Id while duplicating
  const pluginId = courseware.plugin.pluginId;
  const title = courseware.config && courseware.config.title;
  const pluginName = courseware.plugin.name;

  if (!respondToInitChildCallback) {
    const driver = await startPluginShared(
      instanceId, fromJS(manifest), element, context, pluginId, coursewareType, title, pluginName);
    const entry = activePlugins.get(instanceId);
    entry.driver = driver;
  } else {
    startPluginInitChild(fromJS(manifest), pluginId, instanceId, coursewareType, respondToInitChildCallback, title, pluginName);
  }
}

export default invokePlugin;
